import { render, staticRenderFns } from "./SurveyWishes.vue?vue&type=template&id=6f358710&scoped=true&"
import script from "./SurveyWishes.vue?vue&type=script&lang=js&"
export * from "./SurveyWishes.vue?vue&type=script&lang=js&"
import style0 from "./SurveyWishes.vue?vue&type=style&index=0&id=6f358710&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f358710",
  null
  
)

export default component.exports